import DeletePaymentTermContainer from "./DeletePaymentTermContainer";
export default DeletePaymentTermContainer;
